export const Kiosk = 'kiosk'
export const CustomerMonitor = 'customer_monitor'
export const KitchenMonitor = 'kitchen_monitor'
export const Printer = 'printer'
export const QRCode = 'qr_code'
export const Camera = 'camera'
